export default __webpack_public_path__ + "dc6d007fe5d04c1b39e7da9f09dcd451.svg";